import { ERA_CLAIM_ARCHIVE_FAILURE_LABELS } from 'components/lab/billingEraReports/constants'
import { EraArchiveOutcome } from 'components/lab/billingEraReports/types'
import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'

interface Props {
  outcome: EraArchiveOutcome | null
  onClose: () => void
}

export const EraArchiveResultModal = ({ outcome, onClose }: Props) => {
  if (!outcome) return null

  const { result, claims } = outcome
  const claimsById = new Map(claims.map((c) => [c.id, c]))

  return (
    <Modal show onHide={onClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>Archive results</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant={result.failed.length ? 'warning' : 'success'}>
          {result.archived.length} archived
          {result.failed.length > 0 && `, ${result.failed.length} not archived (marked in the list)`}
        </Alert>
        {result.failed.length > 0 && (
          <div className="table-responsive">
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Claim Identifier</th>
                  <th>Patient</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {result.failed.map(({ claimId, reason }) => {
                  const claim = claimsById.get(claimId)

                  return (
                    <tr key={claimId}>
                      <td>{claim?.submittedClaimId || claim?.claimNumber || claimId}</td>
                      <td>{claim?.patientName || '-'}</td>
                      <td>{ERA_CLAIM_ARCHIVE_FAILURE_LABELS[reason] ?? reason}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
